<script setup></script>

<template>
  <div class="omni-dialog-footer row full-width items-center q-col-gutter-y-sm">
    <div class="col-auto">
      <div class="row">
        <div class="col-auto q-pr-md">
          <div class="row">
            <div class="col-12 text-body1 text-grey-7">
              <slot name="footer-info-top-left"></slot>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-body1 text-grey-7">
              <slot name="footer-info-bottom-left"></slot>
            </div>
          </div>
        </div>
        <div class="col-auto">
          <div class="row">
            <div class="col-12 text-body1 text-grey-7">
              <slot name="footer-info-top-right"></slot>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-body1 text-grey-7">
              <slot name="footer-info-bottom-right"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col omni-dialog-footer-actions column items-end">
      <div class="row inline wrap justify-end q-gutter-y-sm">
        <slot name="footer-buttons"></slot>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
